import React from 'react'
import { _useDict } from '~/hooks/useDict'

// TODO: Switch to a proper i18n library, like `react-i18next`!
export const useLang = () => {
  const dictionary = _useDict()
  return ({ children, term = children, ...props }) => {
    let text = dictionary?.app[term] || term

    if (props.replacements) {
      for (let [search, replace] of Object.entries(props.replacements)) {
        text = text.replace(`:${search}`, replace)
      }
    }

    if (text.includes('|')) {
      return Number.isInteger(props.partial)
        ? text.split('|')[props.partial]
        : text.replaceAll('|', '')
    }

    if (props.lowerCase) {
      text = text.toLowerCase()
    }

    return text
  }
}

const Lang = (props) => useLang()(props)

export default Lang
